import { TbMailPlus } from 'react-icons/tb'
import { IResourceConfig } from '@/Core/Contracts/UI'
import { UserResource } from '@/Containers/SettingSection/UserContainer/Resources/UserResource'
import { DriverEditTemplate } from '../Templates/DriverEditTemplate'

export const DriverResource: IResourceConfig = {
    ...UserResource,
    title: 'Водії',
    prefilter: {
        type: 'DRIVER',
    },
    fields: {
        ...UserResource.fields,
        roles: {
            ...UserResource.fields?.['roles'],
            isRequired: false,
            isMultiple: false,
        },
        driverLicenceNumber: {
            label: 'Посвідчення водія',
        },
        isTrainee: {
            label: 'Стажер',
            type: 'switch',
        },
        carrier: {
            label: 'Перевізник',
            type: 'select',
            /** У фільтрі — кілька перевізників (carrier.uuid in […]) */
            isFilterMultiple: true,
            resource: 'Setting.ListCarrier',
            inputProps: {
                filter: {
                    isActive: true,
                },
            },
        },
    },
    table: {
        showColumns: ['fullName', 'phone', 'status', 'driverLicenceNumber', 'isTrainee', 'carrier', 'createdAt'],
    },
    filter: {
        includeFields: [
            'id',
            'fullName',
            'phone',
            'status',
            'driverLicenceNumber',
            'isTrainee',
            'carrier',
            'externalCode',
        ],
    },
    form: {
        template: DriverEditTemplate,
        eventHandlers: {
            onBeforeCreateRequestUrl: {
                injectDriverFields: ({ values }: { values: Record<string, any> }) => {
                    values['type'] = 'DRIVER'
                    if (!values['roles'] || values['roles'].length === 0) {
                        values['roles'] = ['ROLE_DRIVER']
                    }
                },
            },
        },
    },
    settings: {
        showPaginationTotal: true,
    },
    headerPage: {
        eventHandlers: {
            onButtons: {
                InviteDriverButton: ({ buttons, crudContext }: any) => {
                    buttons['InviteDriverButton'] = {
                        label: 'Запросити водія',
                        icon: <TbMailPlus />,
                        sort: 90,
                        priority: 'button',
                        size: 'middle',
                        type: 'default',
                        depFn: ({ crudContext }: any) =>
                            crudContext?.accessFn?.({ accessMode: 'send_invitation', crudContext }) === true,
                        onClick: () => {
                            crudContext.setState('openInviteDrawer', true)
                        },
                    }
                },
            },
        },
    },
}
